import { formatInTimeZone } from 'date-fns-tz/formatInTimeZone'
import { isValid } from 'date-fns/isValid'
import { enGB } from 'date-fns/locale/en-GB'
import { startOfISOWeek } from 'date-fns/startOfISOWeek'

import {
  getServiceDateKey,
  getServiceWeekEnd,
  getServiceWeekStart,
  parseServiceDate,
} from '../MenuHeader/ServiceSelectionGraphql/serviceWeeks'

export function getDateSelectionWeekStart(timezone?: string | null, reference = new Date()) {
  return timezone ? getServiceWeekStart(reference, timezone) : startOfISOWeek(reference)
}

export function isDateInSelectionWeek(value: string, weekStart: Date, timezone: string): boolean {
  const day = getServiceDateKey(value, timezone)
  const start = getServiceDateKey(weekStart, timezone)
  const end = getServiceDateKey(getServiceWeekEnd(weekStart, timezone), timezone)
  return day !== null && start !== null && end !== null && day >= start && day <= end
}

export function formatDateSelectionDate(
  value: string | Date,
  timezone: string,
  pattern: string,
): string {
  const date = parseServiceDate(value, timezone)
  return isValid(date)
    ? formatInTimeZone(date, timezone, pattern, { locale: enGB })
    : 'Invalid date'
}
